module.exports = __webpack_public_path__ + "img/20200421141038271.b1e81ecb.png";